<template>
  <div class="login">
    <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="0px"
             class="demo-ruleForm login-container" @submit.native.prevent>
    <span class="tool-bar">
      <!-- 主题切换 -->
      <!--      <theme-picker style="float:right;" class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>-->
      <!-- 语言切换 -->
      <!-- <lang-selector class="lang-selector"></lang-selector>    -->
    </span>
      <el-tabs v-model="activityTab" @tab-click="tabClick" class="tab_style">
        <el-tab-pane label="账号登录" name="account">
          <el-form-item prop="account">
            <!--<el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="账号"></el-input>-->
            <el-input auto-complete="off" v-model="loginForm.account" placeholder="请输入帐号">
              <template slot="prepend"><i class="kt-icon-gerentouxiang" title="用户名"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="visible" prop="password">
            <el-input type="password" auto-complete="new-password" v-model="loginForm.password"
                      placeholder="请输入新密码" @keyup.enter.native="login">
              <template slot="prepend"><i class="kt-icon-suoding" title="密码"></i></template>
              <i slot="append" title="显示密码" @click="changePass('show')"
                 style="cursor:pointer;background-color: rgba(0, 0, 0, 0)"
                 class="kt-icon-yanjing_xianshi"></i>
              <!--            <i slot="suffix" class="el-icon-delete"></i>-->
            </el-input>
          </el-form-item>
          <el-form-item v-else prop="password">
            <el-input type="text" v-model="loginForm.password" placeholder="请输入新密码">
              <template slot="prepend"><i class="kt-icon-suoding" title="密码"></i></template>
              <i slot="append" title="隐藏密码" @click="changePass('hide')"
                 style="cursor:pointer;background-color: rgba(0, 0, 0, 0);"
                 class="kt-icon-yanjing_yincang"></i>
            </el-input>
          </el-form-item>

        </el-tab-pane>
        <el-tab-pane label="CA登录" name="ca">
          <el-form-item>
            <!--<el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="账号"></el-input>-->
            <div style="border-top: 1px #FFFFFF solid;text-align: right ">
              <span style="float:left;" :style="'color:'+messageColor">{{ cALoginMessage }}</span>
              <el-button type="text" v-if="downloadCA" @click="downloadCAClick">下载CA驱动</el-button>
            </div>
          </el-form-item>
          <el-form-item v-if="visible" prop="password">
            <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" @keyup.enter.native="login">
              <template slot="prepend"><i class="kt-icon-suoding" title="密码"></i></template>
              <i slot="append" title="显示密码" @click="changePass('show')" style="cursor:pointer;"
                 class="kt-icon-yanjing_xianshi"></i>
            </el-input>
          </el-form-item>
          <el-form-item v-else prop="password">
            <el-input type="text" v-model="loginForm.password" placeholder="请输入密码">
              <template slot="prepend"><i class="kt-icon-suoding" title="密码"></i></template>
              <i slot="append" title="隐藏密码" @click="changePass('hide')" style="cursor:pointer;"
                 class="kt-icon-yanjing_yincang"></i>
            </el-input>
          </el-form-item>

        </el-tab-pane>
      </el-tabs>
      <el-form-item>
        <el-col :span="12">
          <el-form-item prop="captcha">
            <el-input type="test" v-model="loginForm.captcha" auto-complete="off" placeholder="验证码, 单击图片刷新"
                      style="width: 100%;">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="1">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item>
            <img style="width: 100%;height: 40px" class="pointer" :src="loginForm.src" @click="refreshCaptcha">
          </el-form-item>
        </el-col>
      </el-form-item>
      <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
      <el-form-item style="width:100%;">
        <!--<el-button type="primary" style="width:48%;" @click.native.prevent="reset">重 置</el-button>-->
        <el-button type="primary" style="width:100%;" @click.native.prevent="login" :loading="loading"
                   native-type="submit">登 录
        </el-button>

        <el-button style="width:100%;margin-left: 0px;margin-top: 10px"
                   @click.native.prevent="register">注 册
        </el-button>
      </el-form-item>
    </el-form>

    <div>
      <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="30%">
        <span style="color: red;font-size: 12px;padding-left: 10px">密码有效期已到,请重新设置密码</span>
        <el-form ref="updatePasswordForm" :model="updatePasswordForm" :rules="passwordRules" label-width="80px"
                 style="padding-top: 20px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="旧密码" prop="oldPassword">
                <el-input placeholder="请输入旧密码" v-model="updatePasswordForm.oldPassword" show-password></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top: 10px">
            <el-col :span="24">
              <el-form-item label="新密码" prop="newPassword">
                <el-input placeholder="请输入新密码" v-model="updatePasswordForm.newPassword" show-password></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top: 10px">
            <el-col :span="24">
              <el-form-item label="确认密码" prop="newPasswordAgain">
                <el-input placeholder="请再次输入新密码" v-model="updatePasswordForm.newPasswordAgain"
                          show-password></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeDialog">取 消</el-button>
          <el-button size="mini" type="primary" @click="updatePassword">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {encode64, generateRandomString} from "@/utils/encode64"
import {mapState} from 'vuex';
import Cookies from 'js-cookie';
import ThemePicker from '@/components/ThemePicker';
import LangSelector from '@/components/LangSelector';
import {CA} from '@/utils/cert';
import {updatePassword} from "../http/moudules/login";

export default {
  name: 'Login',
  components: {
    ThemePicker,
    LangSelector,
  },
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.updatePasswordForm.newPassword !== value) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      activityTab: 'account',
      loading: false,
      downloadCA: false,
      messageColor: 'red',//提示信息的颜色
      cALoginMessage: '',//CA登录时的提示信息
      loginForm: {
        account: '',
        password: '',
        captcha: '',
        src: '',
      },
      visible: true,
      fieldRules: {
        account: [
          {required: true, message: '请输入账号', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ]
        ,
        captcha: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
      },
      checked: true,
      dialogVisible: false,
      // 表单校验
      passwordRules: {
        oldPassword: [
          {required: true, message: '旧密码不能为空', trigger: 'blur'}
        ],
        newPassword: [
          {required: true, message: '新密码不能为空', trigger: 'blur'},
          {min: 8, max: 20, message: '新密码最少长度为8位，且由数字、字母、特殊符号三种以及三种以上组成', trigger: 'blur'},
          {
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,30}$/,
            message: '新密码最少长度为8位，且由数字、字母、特殊符号三种以及三种以上组成',
            trigger: 'blur'
          }
        ],
        newPasswordAgain: [
          {required: true, message: '确认密码不能为空', trigger: 'blur'},
          {required: true, validator: equalToPassword, trigger: 'blur'}
        ]
      },
      updatePasswordForm: {
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: ''
      }
    };
  },
  methods: {
    changePass(value) {
      console.log('点击了显示密码');
      this.visible = !(value === 'show');
    },
    loginIn(res) {
      if (res.code != 200) {
        this.refreshCaptcha()
        this.$message({
          message: res.msg,
          type: 'error',
        });
      } else {
        const updatePassFlag = res.data.updatePassFlag
        if (updatePassFlag) {
          this.dialogVisible = true
        } else {
          Cookies.set('token', res.data.token || res.data); // 兼容直接返回token或者返回json对象包含token，然后把token到Cookie
          this.$api.user.findUserInfo().then((res) => {
            let user = res.data;
            sessionStorage.setItem('user', user.loginName); // 保存用户到本地会话
            this.$store.commit('menuRouteLoaded', false); // 要求重新加载导航菜单
            this.$store.commit('setDeptId', user['deptId']);
            let roles = [];
            if (user.roles) {
              for (let i = 0; i < user.roles.length; i++) {
                let row = user.roles[i];
                roles.push(row.code);
              }
            }
            this.$store.commit('setRoles', roles);
            setTimeout(() => {
              console.log('进入首页');
              this.$router.push('/');  // 登录成功，跳转到主页
            }, 1);
          });
        }
      }
      this.loading = false;
    },
    login() {
      this.$refs['loginForm'].validate(function (valid) {
        if (valid) {
          this.loading = true;
          if (this.activityTab === 'account') {//账号密码登录
            let userInfo = {
              account: this.loginForm.account,
              password: generateRandomString(6) + encode64(this.loginForm.password) + generateRandomString(6),
              captcha: this.loginForm.captcha
            };

            this.$api.login.login(userInfo).then(this.loginIn).catch((res) => {
              this.$message({
                message: res.message,
                type: 'error',
              });
            });
          } else {//CA登录
            console.log('点击了确定');
            this.CA.getCertInfo(this.loginForm.password).then(res => {
              try {
                this.$api.deptExtend.caLogin(res, {'captcha': this.loginForm.captcha}).then(this.loginIn).catch((res) => {
                  this.$message({
                    message: res.message,
                    type: 'error',
                  });
                });
              } catch (e) {
                this.loading = false;
                this.$message.error(e.message);
              }
            }).catch(e => {
              this.$message.error(e.message);
            });
          }

        }
      }.bind(this));
    },
    register: function () {
      this.$router.push('/register');//跳转到注册页
    },
    refreshCaptcha: function () {
      this.loginForm.src = this.global.baseUrl + '/login/captcha.jpg?t=' + new Date().getTime();
    },
    reset() {
      this.$refs.loginForm.resetFields();
    },
    // 切换主题
    onThemeChange: function (themeColor) {
      this.$store.commit('setThemeColor', themeColor);
    },
    checkCA: function () {
      this.CA = new CA();
      this.CA.initService().then((str) => {
        this.cALoginMessage = 'CA锁加载成功，请输入密码！';
        this.messageColor = 'rgba(130, 130, 130, 1)';
        this.downloadCA = false;
      }).catch(error => {
        console.error(error);
        this.cALoginMessage = '未检测到CA锁，请检查驱动和插入CA锁！';
        this.downloadCA = true;
        this.messageColor = 'red';
      });

    },
    tabClick: function () {
      if (this.activityTab === 'ca') {
        this.cALoginMessage = '正在加载CA锁！';
        this.messageColor = 'rgba(130, 130, 130, 1)';
        setTimeout(function () {
          this.checkCA();
          this.loginForm.account = 'ca';
          this.loginForm.password = '';
        }.bind(this));
      } else {
        this.loginForm.account = '';
        this.loginForm.password = '';
      }
    },
    downloadCAClick: function () {
      window.open('https://www.962600.com/resources/tools', '_blank');
    },
    updatePassword() {
      let regex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,30}$')
      if (!this.updatePasswordForm.oldPassword) {
        this.$message.error("旧密码不能为空")
        return
      }
      if (!this.updatePasswordForm.newPassword) {
        this.$message.error("新密码不能为空")
        return
      }
      if (!this.updatePasswordForm.newPasswordAgain) {
        this.$message.error("新密码确认不能为空")
        return
      }
      if (this.updatePasswordForm.newPassword.length < 8 || !regex.test(this.updatePasswordForm.newPassword)) {
        this.$message.error("新密码最少长度为8位，且由数字、字母、特殊符号三种以及三种以上组成")
        return
      }
      if (this.updatePasswordForm.oldPassword == this.updatePasswordForm.newPassword) {
        this.$message.error("新密码和旧密码不能一样")
        return
      }
      if (this.updatePasswordForm.newPasswordAgain != this.updatePasswordForm.newPassword) {
        this.$message.error("两次输入的新密码不一致")
        return
      }
      this.$refs.updatePasswordForm.validate(valid => {
        if (valid) {
          let oldPassword = encode64(this.updatePasswordForm.oldPassword)
          let newPassword = encode64(this.updatePasswordForm.newPassword)
          let params = {username: this.loginForm.account, oldPassword: oldPassword, newPassword: newPassword}
          updatePassword(params).then(response => {
            if (response.data) {
              this.loginForm.password = ''
              this.$message.success("修改成功")
              this.closeDialog()
            } else {
              this.$message.error("旧密码输入错误")
            }
          })
        }
      })
    },
    closeDialog() {
      this.dialogVisible = false
      this.loading = false
      this.refreshCaptcha()
    }

  },
  mounted() {
    this.refreshCaptcha();
    //onThemeChange('#053999');
  },
  computed: {
    ...mapState({
      themeColor: state => state.app.themeColor,
    }),
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  height: 100%;
  width: 100%;
  background: url("../assets/login_bg.png") center center;
  background-size: cover;
}

.login-container {
  -webkit-border-radius: 0px;
  border-radius: 0px;
  -moz-border-radius: 0px;
  background-clip: padding-box;
  margin: 0 auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -175px;

  .title {
    margin: 0px auto 30px auto;
    text-align: center;
    color: #505458;
    font-size: 24px;
    padding: 0;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }
}

#app > form {
  height: 360px !important;
  margin: auto !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  position: absolute;
}

i {
  font-size: 25px;
}

.tab_style {
  .el-tabs__nav {
    width: 100%;
  }
}


</style>
<style>
.login-container .el-input-group__append {
  background-color: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue